import { useLocaleField } from '@/hooks/useLocaleField';
import { useSiteSettings } from '@/hooks/useSiteSettings';
import { Box, Divider, Heading, Link } from '@chakra-ui/react';
import { PortableText } from '@portabletext/react';
import { FC } from 'react';
import styles from './RoomActions.module.css';
import { RoomActionsProps } from './RoomActions.props';

const RoomActions: FC<RoomActionsProps> = ({ room }) => {
  const { getLocaleBlock } = useLocaleField();
  const { mobile } = useSiteSettings();

  return (
    <Box p={{ md: '0 0 0 30px' }} className={styles.ActionWrapper}>
      <Box mt="4rem">
        <Link href={`tel:${mobile}`} display="block" textAlign="center" backgroundColor="primary" color="white" p={3}>
          Call us now
        </Link>
      </Box>
      <Divider my={25} />
      <Box my="2rem" alignContent="center" lineHeight="2rem" backgroundColor="primary-100" p={15}>
        <Heading mb="1rem" as="h4" fontWeight="normal" color="gray.700" fontSize="xl">
          Additional information
        </Heading>
        <Box className={styles.AdditionalInfo} justifyContent="center" pl={15}>
          <PortableText value={getLocaleBlock(room.additionalInfo)} />
        </Box>
      </Box>
    </Box>
  );
};

export { RoomActions };
